import Regex from '../regex';

$(document).ready(function () {
    const form = document.getElementById("connected-quote");
    const emailInput = document.getElementById("email");
    const error = document.getElementById("error");
    if (!form || !emailInput || !error) {
         return;
    }
    form.addEventListener("submit", function(event) {
        const emailValue = emailInput.value;

        if (!Regex.email.test(emailValue)) {
            event.preventDefault();
            error.classList.remove("d-none");
            error.textContent = "Please enter a valid email address";
            emailInput.focus();
        }else {
            error.classList.add("d-none");
            error.textContent = "";
        }
      })
});
